import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { TranslationLookupModule } from '@main-client/src/app/pipes/translation-lookup/translation-lookup.module';

import { MatchExclusionsBackend } from '@libs/src/match-exclusions/match-exclusions.backend';
import { GroupIntroSelectionsFormService } from '@main-client/src/app/group-intro-selections-form/group-intro-selections-form.service';

import { GroupIntroSelectionsFormComponent } from './group-intro-selections-form.component';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    MatChipsModule,
    MatIconModule,
    MatTooltipModule,
    ReactiveFormsModule,
    TranslationLookupModule,
  ],
  declarations: [GroupIntroSelectionsFormComponent],
  exports: [GroupIntroSelectionsFormComponent],
  providers: [GroupIntroSelectionsFormService, MatchExclusionsBackend],
})
export class GroupIntroSelectionsFormModule {}
